((app, ng) => {

    app.controller("acmAccountController", acmAccountController);

    function acmAccountController($q, $mdDialog, externalAccountApi) {
		const $ctrl = this;

		const close = () => {
		    $mdDialog.hide();
		}

	    ng.extend($ctrl,
	        {
	            close,
	        });

		$ctrl.$onInit = () => {
            $ctrl.requests = [];
            $ctrl.ui = {
                loading: true,
            }

		    const promises = [
		        externalAccountApi.getAcmAccount($ctrl.acmAccountGuid),
		        externalAccountApi.getAcmAccountRequests($ctrl.acmAccountGuid),
            ];

		    $q.all(promises).then(responses => {
		        [$ctrl.account, $ctrl.requests] = responses;
		        $ctrl.ui.loading = false;
		    });
        };
	}
})(window.app, window.angular);